import { PendingContributionsService } from '@festina/moneyin-general-types/moneyin/services/PendingContributionsService'
import { useFestinaMutation } from '@festina-life/authentication'
import type { Except } from '@festina-life/core'

const method =
  PendingContributionsService.pendingContributionsServicePostReconcileWithPaymentSpecifications
type MethodParam = Parameters<typeof method>[0]

export const useSubmitReconciledContributions = ({
  tenantId,
}: {
  tenantId: string
}) =>
  useFestinaMutation({
    component: 'moneyIn',
    isScenario: false,
    roles:
      PendingContributionsService.pendingContributionsServicePostReconcileWithPaymentSpecifications_roles,

    mutateFunction: async (arg: Except<MethodParam, 'xTenantId'>) =>
      await method({
        xTenantId: tenantId,
        ...arg,
      }),
  })
